export default "__VITE_ASSET__BnskMuUK__"